import type { UserEntity } from '@ts/core/src/modules/user/user.entity'
import type { StoreEntity } from '@ts/core/src/modules/store/store.entity'

export const getUserStores = (user?: UserEntity | null): StoreEntity[] => {
  const stores = user?.stores?.filter(store => !store.deletedAt) ?? []

  if (stores.length) {
    return stores
  }

  return user?.store && !user.store.deletedAt ? [user.store] : []
}

export const hasMultipleStores = (user?: UserEntity | null): boolean => {
  return getUserStores(user).length > 1
}

export const needsStoreSelection = (user?: UserEntity | null): boolean => {
  return hasMultipleStores(user) && !user?.store
}
